import { StarIcon } from '@eureca/ui/icons';
import type { PotentialCriterionScore } from './potential-criteria';

const STAR_SLOTS = [1, 2, 3, 4, 5] as const;

/**
 * DEV-286 (spec 142) — as cinco notas de potencial dentro do card da avaliação,
 * no formato do App Gestores (AC-17/AC-18): uma linha por critério, rótulo à
 * esquerda e cinco estrelas à direita, sólidas no número exato da nota e em
 * contorno nas demais. Sem o rótulo "Critérios de potencial" (as linhas
 * aparecem direto) e SOMENTE LEITURA (AC-20): nenhum handler, botão ou link.
 * Leitor de tela anuncia o grupo de estrelas como "Rótulo: n de 5" (POT-016);
 * as estrelas em si são decorativas. Puro: sem hooks.
 */
export function PotentialCriteriaRows({ scores }: { scores: PotentialCriterionScore[] }) {
  return (
    <ul
      data-testid="evaluation-potential-criteria"
      className="flex flex-col gap-2 border-y border-border py-3"
    >
      {scores.map((score) => (
        <li key={score.key} className="flex flex-row items-center justify-between gap-6">
          <span
            data-testid="potential-criterion-label"
            className="min-w-0 break-words text-sm leading-5 text-muted-foreground"
          >
            {score.label}
          </span>
          <span
            role="img"
            aria-label={`${score.label}: ${score.value} de 5`}
            className="flex shrink-0 flex-row items-center gap-1 text-primary"
          >
            {STAR_SLOTS.map((slot) => {
              const filled = slot <= score.value;
              return (
                <StarIcon
                  key={slot}
                  data-star={slot}
                  data-filled={filled ? 'true' : 'false'}
                  fill={filled ? 'currentColor' : 'none'}
                  className="size-4"
                />
              );
            })}
          </span>
        </li>
      ))}
    </ul>
  );
}
